import { render, staticRenderFns } from "./ConflictList.vue?vue&type=template&id=28c60c08&scoped=true&"
import script from "./ConflictList.vue?vue&type=script&lang=js&"
export * from "./ConflictList.vue?vue&type=script&lang=js&"
import style0 from "./ConflictList.vue?vue&type=style&index=0&id=28c60c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/ronaspergel/Projects/otjs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c60c08",
  null
  
)

export default component.exports